/* eslint-disable */
// @ts-nocheck
/* ONEKYC — scene-canvas Web Component (ported from the design prototype).
   Lightweight monochrome canvas engine for "technical" scenes.
   <scene-canvas scene="kyc-01"> — change the `scene` attribute to cross-fade.
   Self-contained: no dependencies, pauses off-screen via IntersectionObserver.

   Call registerSceneCanvas() once on the client to define the element. */
export function registerSceneCanvas() {
	if (typeof window === 'undefined' || typeof customElements === 'undefined')
		return;
	if (customElements.get('scene-canvas')) return;

	const TAU = Math.PI * 2;
	const lerp = (a, b, t) => a + (b - a) * t;
	const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
	const ease = (t) => t * t * (3 - 2 * t);
	const W = (a) => 'rgba(255,255,255,' + a + ')';
	function rng(seed) {
		let a = seed >>> 0 || 1;
		return () => {
			a |= 0;
			a = (a + 0x6d2b79f5) | 0;
			let t = Math.imul(a ^ (a >>> 15), 1 | a);
			t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
			return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
		};
	}
	function hash(s) {
		let h = 2166136261;
		for (let i = 0; i < s.length; i++) {
			h ^= s.charCodeAt(i);
			h = Math.imul(h, 16777619);
		}
		return h >>> 0;
	}

	function bg(ctx, w, h) {
		ctx.fillStyle = '#0a0a0b';
		ctx.fillRect(0, 0, w, h);
		ctx.strokeStyle = 'rgba(255,255,255,0.04)';
		ctx.lineWidth = 1;
		const step = Math.max(34, Math.round(w / 26));
		for (let x = step; x < w; x += step) {
			ctx.beginPath();
			ctx.moveTo(x + 0.5, 0);
			ctx.lineTo(x + 0.5, h);
			ctx.stroke();
		}
		for (let y = step; y < h; y += step) {
			ctx.beginPath();
			ctx.moveTo(0, y + 0.5);
			ctx.lineTo(w, y + 0.5);
			ctx.stroke();
		}
	}
	function vignette(ctx, w, h) {
		const g = ctx.createRadialGradient(
			w / 2,
			h / 2,
			h * 0.15,
			w / 2,
			h / 2,
			h * 0.95,
		);
		g.addColorStop(0, 'rgba(0,0,0,0)');
		g.addColorStop(1, 'rgba(0,0,0,0.62)');
		ctx.fillStyle = g;
		ctx.fillRect(0, 0, w, h);
	}
	function corners(ctx, w, h) {
		ctx.strokeStyle = 'rgba(255,255,255,0.45)';
		ctx.lineWidth = 1.5;
		const m = Math.round(Math.min(w, h) * 0.045),
			l = Math.round(Math.min(w, h) * 0.05);
		[
			[m, m, 1, 1],
			[w - m, m, -1, 1],
			[m, h - m, 1, -1],
			[w - m, h - m, -1, -1],
		].forEach(([x, y, sx, sy]) => {
			ctx.beginPath();
			ctx.moveTo(x, y + sy * l);
			ctx.lineTo(x, y);
			ctx.lineTo(x + sx * l, y);
			ctx.stroke();
		});
	}

	function rrect(ctx, x, y, w, h, r) {
		r = Math.min(r, w / 2, h / 2);
		ctx.beginPath();
		ctx.moveTo(x + r, y);
		ctx.arcTo(x + w, y, x + w, y + h, r);
		ctx.arcTo(x + w, y + h, x, y + h, r);
		ctx.arcTo(x, y + h, x, y, r);
		ctx.arcTo(x, y, x + w, y, r);
		ctx.closePath();
	}

	function faceModel() {
		const groups = [
			{
				z: 0.02,
				p: [
					[-0.55, -0.45],
					[-0.5, -0.62],
					[-0.4, -0.78],
					[-0.25, -0.9],
					[0, -0.96],
					[0.25, -0.9],
					[0.4, -0.78],
					[0.5, -0.62],
					[0.55, -0.45],
				],
			},
			{
				z: -0.12,
				p: [
					[-0.62, -0.2],
					[-0.66, 0.05],
					[-0.6, 0.3],
				],
			},
			{
				z: -0.12,
				p: [
					[0.62, -0.2],
					[0.66, 0.05],
					[0.6, 0.3],
				],
			},
			{
				z: -0.06,
				p: [
					[-0.5, 0.5],
					[-0.3, 0.68],
					[0, 0.74],
					[0.3, 0.68],
					[0.5, 0.5],
				],
			},
			{
				z: 0.1,
				p: [
					[-0.5, 0.32],
					[-0.38, 0.4],
					[-0.24, 0.4],
					[-0.12, 0.34],
				],
			},
			{
				z: 0.1,
				p: [
					[0.12, 0.34],
					[0.24, 0.4],
					[0.38, 0.4],
					[0.5, 0.32],
				],
			},
			{
				z: 0.07,
				loop: true,
				p: [
					[-0.42, 0.2],
					[-0.34, 0.27],
					[-0.22, 0.26],
					[-0.16, 0.18],
					[-0.24, 0.12],
					[-0.36, 0.13],
				],
			},
			{
				z: 0.07,
				loop: true,
				p: [
					[0.16, 0.18],
					[0.22, 0.26],
					[0.34, 0.27],
					[0.42, 0.2],
					[0.36, 0.13],
					[0.24, 0.12],
				],
			},
			{
				z: 0.2,
				p: [
					[0, 0.3],
					[0, 0.12],
					[0, -0.05],
					[0, -0.18],
				],
			},
			{
				z: 0.3,
				p: [
					[-0.14, -0.24],
					[-0.06, -0.28],
					[0, -0.31],
					[0.06, -0.28],
					[0.14, -0.24],
				],
			},
			{
				z: 0.13,
				loop: true,
				p: [
					[-0.22, -0.5],
					[-0.1, -0.46],
					[0, -0.48],
					[0.1, -0.46],
					[0.22, -0.5],
					[0.1, -0.56],
					[0, -0.58],
					[-0.1, -0.56],
				],
			},
		];
		const pts = [],
			edges = [],
			eset = {};
		const addE = (a, b) => {
			if (a === b) return;
			const k = a < b ? a + '_' + b : b + '_' + a;
			if (eset[k]) return;
			eset[k] = 1;
			edges.push([a, b]);
		};
		groups.forEach((g) => {
			const st = pts.length;
			g.p.forEach((q, i) =>
				pts.push({ x: q[0], y: q[1], z: g.z, ph: (st + i) * 1.7 }),
			);
			for (let i = 0; i < g.p.length - 1; i++) addE(st + i, st + i + 1);
			if (g.loop) addE(st + g.p.length - 1, st);
		});
		for (let i = 0; i < pts.length; i++) {
			const d = [];
			for (let j = 0; j < pts.length; j++) {
				if (i === j) continue;
				const dx = pts[i].x - pts[j].x,
					dy = pts[i].y - pts[j].y,
					dz = pts[i].z - pts[j].z;
				d.push([dx * dx + dy * dy + dz * dz * 0.4, j]);
			}
			d.sort((a, b) => a[0] - b[0]);
			for (let k = 0; k < 3; k++) if (d[k] && d[k][0] < 0.12) addE(i, d[k][1]);
		}
		return { pts: pts, edges: edges };
	}

	const SCENES = {
		'kyc-01': {
			// DOCUMENT — scan + OCR reveal
			reset(s) {
				const r = s._r;
				s.lines = [];
				for (let i = 0; i < 9; i++)
					s.lines.push({ y: i / 9, w: 0.3 + r() * 0.6, rs: (r() * 1e4) | 0 });
				s.fm = faceModel();
			},
			draw(ctx, w, h, t, dt, s) {
				const dx = 0.15 * w,
					dy = 0.12 * h,
					dw = 0.7 * w,
					dh = 0.66 * h;
				ctx.strokeStyle = W(0.25);
				ctx.lineWidth = 1.5;
				ctx.strokeRect(dx, dy, dw, dh);
				const px = dx + 0.03 * w,
					py = dy + 0.06 * h,
					pw = 0.13 * w,
					ph = 0.34 * h;
				ctx.strokeStyle = W(0.3);
				ctx.strokeRect(px, py, pw, ph);
				ctx.save();
				ctx.beginPath();
				ctx.rect(px, py, pw, ph);
				ctx.clip();
				const fA = 0.28 * Math.sin(t * 0.5),
					fcA = Math.cos(fA),
					fsA = Math.sin(fA);
				const raw = s.fm.pts.map((q) => {
					const xx = q.x * fcA + q.z * fsA,
						zz = -q.x * fsA + q.z * fcA,
						pe = 1 / (1 - zz * 0.3);
					return { x: xx * pe, y: q.y * pe, z: zz };
				});
				let mnx = 1e9,
					mxx = -1e9,
					mny = 1e9,
					mxy = -1e9;
				raw.forEach((q) => {
					if (q.x < mnx) mnx = q.x;
					if (q.x > mxx) mxx = q.x;
					if (q.y < mny) mny = q.y;
					if (q.y > mxy) mxy = q.y;
				});
				const fS = Math.min(
					(pw * 0.78) / (mxx - mnx || 1),
					(ph * 0.82) / (mxy - mny || 1),
				);
				const ox = px + pw / 2 - ((mnx + mxx) / 2) * fS,
					oy = py + ph / 2 + ((mny + mxy) / 2) * fS;
				const fpj = raw.map((q) => ({
					sx: ox + q.x * fS,
					sy: oy - q.y * fS,
					z: q.z,
				}));
				for (let e = 0; e < s.fm.edges.length; e++) {
					const P = fpj[s.fm.edges[e][0]],
						Q = fpj[s.fm.edges[e][1]];
					ctx.strokeStyle = W(clamp(0.22 + (P.z + Q.z) * 0.4, 0.08, 0.5));
					ctx.lineWidth = 1;
					ctx.beginPath();
					ctx.moveTo(P.sx, P.sy);
					ctx.lineTo(Q.sx, Q.sy);
					ctx.stroke();
				}
				ctx.fillStyle = W(0.62);
				fpj.forEach((P) => {
					const z = 1.4 + clamp(0.4 + P.z * 0.6, 0, 1) * 1.2;
					ctx.fillRect(P.sx - z / 2, P.sy - z / 2, z, z);
				});
				ctx.restore();
				const per = 4.6,
					p = (t % per) / per,
					scanY = dy + 0.1 * h + p * (dh - 0.14 * h);
				const tx = dx + 0.19 * w,
					tw = dw - 0.22 * w;
				s.lines.forEach((ln) => {
					const ly = dy + 0.1 * h + ln.y * (dh - 0.16 * h),
						lw = tw * ln.w;
					if (ly < scanY - 2) {
						const jp = Math.abs(ly - scanY) < 26 ? 0.5 : 0;
						ctx.fillStyle = W(clamp(0.16 + jp, 0, 0.7));
						ctx.fillRect(tx, ly, lw, 6);
					} else {
						const r = rng(ln.rs + ((t * 14) | 0));
						let x = tx;
						while (x < tx + lw) {
							const seg = 6 + r() * 22;
							if (r() > 0.35) {
								ctx.fillStyle = W(0.05 + r() * 0.1);
								ctx.fillRect(x, ly, seg, 6);
							}
							x += seg + 4;
						}
					}
				});
				const g = ctx.createLinearGradient(0, scanY - 42, 0, scanY + 42);
				g.addColorStop(0, W(0));
				g.addColorStop(0.5, W(0.16));
				g.addColorStop(1, W(0));
				ctx.fillStyle = g;
				ctx.fillRect(dx, scanY - 42, dw, 84);
				ctx.strokeStyle = W(0.95);
				ctx.lineWidth = 2;
				ctx.beginPath();
				ctx.moveTo(dx, scanY);
				ctx.lineTo(dx + dw, scanY);
				ctx.stroke();
				ctx.fillStyle = W(0.3);
				for (let i = 0; i <= 10; i++) {
					const yy = dy + (i / 10) * dh;
					ctx.fillRect(dx - 6, yy, 4, 1);
				}
			},
		},
		'kyc-02': {
			// BIOMETRICS — rotating 3D landmark face
			reset(s) {
				const groups = [
					{
						z: 0.02,
						p: [
							[-0.55, -0.45],
							[-0.5, -0.62],
							[-0.4, -0.78],
							[-0.25, -0.9],
							[0, -0.96],
							[0.25, -0.9],
							[0.4, -0.78],
							[0.5, -0.62],
							[0.55, -0.45],
						],
					},
					{
						z: -0.12,
						p: [
							[-0.62, -0.2],
							[-0.66, 0.05],
							[-0.6, 0.3],
						],
					},
					{
						z: -0.12,
						p: [
							[0.62, -0.2],
							[0.66, 0.05],
							[0.6, 0.3],
						],
					},
					{
						z: -0.06,
						p: [
							[-0.5, 0.5],
							[-0.3, 0.68],
							[0, 0.74],
							[0.3, 0.68],
							[0.5, 0.5],
						],
					},
					{
						z: 0.1,
						p: [
							[-0.5, 0.32],
							[-0.38, 0.4],
							[-0.24, 0.4],
							[-0.12, 0.34],
						],
					},
					{
						z: 0.1,
						p: [
							[0.12, 0.34],
							[0.24, 0.4],
							[0.38, 0.4],
							[0.5, 0.32],
						],
					},
					{
						z: 0.07,
						loop: true,
						p: [
							[-0.42, 0.2],
							[-0.34, 0.27],
							[-0.22, 0.26],
							[-0.16, 0.18],
							[-0.24, 0.12],
							[-0.36, 0.13],
						],
					},
					{
						z: 0.07,
						loop: true,
						p: [
							[0.16, 0.18],
							[0.22, 0.26],
							[0.34, 0.27],
							[0.42, 0.2],
							[0.36, 0.13],
							[0.24, 0.12],
						],
					},
					{
						z: 0.2,
						p: [
							[0, 0.3],
							[0, 0.12],
							[0, -0.05],
							[0, -0.18],
						],
					},
					{
						z: 0.3,
						p: [
							[-0.14, -0.24],
							[-0.06, -0.28],
							[0, -0.31],
							[0.06, -0.28],
							[0.14, -0.24],
						],
					},
					{
						z: 0.13,
						loop: true,
						p: [
							[-0.22, -0.5],
							[-0.1, -0.46],
							[0, -0.48],
							[0.1, -0.46],
							[0.22, -0.5],
							[0.1, -0.56],
							[0, -0.58],
							[-0.1, -0.56],
						],
					},
				];
				const pts = [],
					edges = [],
					eset = {};
				const addE = (a, b) => {
					if (a === b) return;
					const k = a < b ? a + '_' + b : b + '_' + a;
					if (eset[k]) return;
					eset[k] = 1;
					edges.push([a, b]);
				};
				groups.forEach((g) => {
					const st = pts.length;
					g.p.forEach((q, i) =>
						pts.push({ x: q[0], y: q[1], z: g.z, ph: (st + i) * 1.7 }),
					);
					for (let i = 0; i < g.p.length - 1; i++) addE(st + i, st + i + 1);
					if (g.loop) addE(st + g.p.length - 1, st);
				});
				for (let i = 0; i < pts.length; i++) {
					const d = [];
					for (let j = 0; j < pts.length; j++) {
						if (i === j) continue;
						const dx = pts[i].x - pts[j].x,
							dy = pts[i].y - pts[j].y,
							dz = pts[i].z - pts[j].z;
						d.push([dx * dx + dy * dy + dz * dz * 0.4, j]);
					}
					d.sort((a, b) => a[0] - b[0]);
					for (let k = 0; k < 3; k++)
						if (d[k] && d[k][0] < 0.12) addE(i, d[k][1]);
				}
				s.pts = pts;
				s.edges = edges;
			},
			draw(ctx, w, h, t, dt, s) {
				const A = 0.55 * Math.sin(t * 0.35),
					B = 0.1 * Math.sin(t * 0.27);
				const cA = Math.cos(A),
					sA = Math.sin(A),
					cB = Math.cos(B),
					sB = Math.sin(B);
				const cx = w / 2,
					cy = h * 0.47,
					S = Math.min(w * 0.3, h * 0.4);
				const pr = s.pts.map((p) => {
					const jx = Math.sin(t * 0.9 + p.ph) * 0.006,
						jy = Math.cos(t * 0.8 + p.ph) * 0.006;
					let x = (p.x + jx) * cA + p.z * sA;
					let z = -(p.x + jx) * sA + p.z * cA;
					let y = (p.y + jy) * cB - z * sB;
					z = (p.y + jy) * sB + z * cB;
					const per = 1 / (1 - z * 0.32);
					return { sx: cx + x * S * per, sy: cy - y * S * per, z: z };
				});
				const sp = (t * 0.22) % 1,
					scanY = cy - 0.95 * S + sp * 1.9 * S;
				for (let e = 0; e < s.edges.length; e++) {
					const P = pr[s.edges[e][0]],
						Q = pr[s.edges[e][1]];
					ctx.strokeStyle = W(clamp(0.16 + (P.z + Q.z) * 0.5, 0.05, 0.55));
					ctx.lineWidth = 1;
					ctx.beginPath();
					ctx.moveTo(P.sx, P.sy);
					ctx.lineTo(Q.sx, Q.sy);
					ctx.stroke();
				}
				pr.forEach((P) => {
					const near = clamp(1 - Math.abs(P.sy - scanY) / 32, 0, 1);
					const dz = clamp(0.4 + P.z * 0.7, 0, 1);
					ctx.fillStyle = W(clamp(0.28 + dz * 0.5 + near * 0.4, 0, 1));
					const z = 1.6 + dz * 1.8 + near * 2.4;
					ctx.fillRect(P.sx - z / 2, P.sy - z / 2, z, z);
				});
				const g = ctx.createLinearGradient(0, scanY - 28, 0, scanY + 28);
				g.addColorStop(0, W(0));
				g.addColorStop(0.5, W(0.13));
				g.addColorStop(1, W(0));
				ctx.fillStyle = g;
				ctx.fillRect(0, scanY - 28, w, 56);
				ctx.strokeStyle = W(0.5);
				ctx.lineWidth = 1.2;
				ctx.beginPath();
				ctx.moveTo(w * 0.06, scanY);
				ctx.lineTo(w * 0.94, scanY);
				ctx.stroke();
				let mnx = 1e9,
					mny = 1e9,
					mxx = -1e9,
					mxy = -1e9;
				pr.forEach((P) => {
					if (P.sx < mnx) mnx = P.sx;
					if (P.sy < mny) mny = P.sy;
					if (P.sx > mxx) mxx = P.sx;
					if (P.sy > mxy) mxy = P.sy;
				});
				const pad = 16;
				mnx -= pad;
				mny -= pad;
				mxx += pad;
				mxy += pad;
				const bl = clamp((mxx - mnx) * 0.18, 12, 26);
				ctx.strokeStyle = W(0.4);
				ctx.lineWidth = 1.3;
				[
					[mnx, mny, 1, 1],
					[mxx, mny, -1, 1],
					[mnx, mxy, 1, -1],
					[mxx, mxy, -1, -1],
				].forEach((c) => {
					ctx.beginPath();
					ctx.moveTo(c[0], c[1] + c[3] * bl);
					ctx.lineTo(c[0], c[1]);
					ctx.lineTo(c[0] + c[2] * bl, c[1]);
					ctx.stroke();
				});
			},
		},
		'kyc-03': {
			// DATA — streams + packets
			reset(s) {
				const r = s._r;
				s.n = 40;
				s.c = [];
				for (let c = 0; c < s.n; c++)
					s.c.push({ off: r(), sp: 0.15 + r() * 0.5, pk: [], nx: r() * 2 });
			},
			draw(ctx, w, h, t, dt, s) {
				const cw = w / s.n;
				for (let c = 0; c < s.n; c++) {
					const o = s.c[c];
					o.off = (o.off + o.sp * dt) % 1;
					for (let k = 0; k < 26; k++) {
						const yy = ((o.off + k / 26) % 1) * (h + 40) - 20;
						const a = 0.04 + (((k * 7 + c) % 5) / 5) * 0.16;
						ctx.fillStyle = W(a);
						ctx.fillRect(c * cw + cw * 0.22, yy, cw * 0.5, 5);
					}
					o.nx -= dt;
					if (o.nx <= 0) {
						o.nx = 0.6 + s._r() * 2.2;
						o.pk.push({ y: -20, v: 120 + s._r() * 180 });
					}
					o.pk.forEach((p) => (p.y += p.v * dt));
					o.pk = o.pk.filter((p) => p.y < h + 30);
					o.pk.forEach((p) => {
						for (let tr = 0; tr < 5; tr++) {
							ctx.fillStyle = W(clamp(0.85 - tr * 0.18, 0, 1));
							ctx.fillRect(c * cw + cw * 0.22, p.y - tr * 8, cw * 0.5, 6);
						}
					});
				}
			},
		},
		'kyc-04': {
			// AML — watchlist + crosshair lock
			reset(s) {
				const r = s._r;
				s.cols = 16;
				s.rows = 8;
				s.hits = [];
				for (let i = 0; i < s.cols * s.rows; i++)
					s.hits.push(r() < 0.12 ? r() * 0.5 + 0.4 : 0);
				s.cur = [r() * s.cols, r() * s.rows];
				s.tgt = [(r() * s.cols) | 0, (r() * s.rows) | 0];
				s.lock = 0;
			},
			draw(ctx, w, h, t, dt, s) {
				const gx = 0.1 * w,
					gy = 0.12 * h,
					gw = 0.8 * w,
					gh = 0.66 * h,
					cw = gw / s.cols,
					ch = gh / s.rows;
				if (s._r() < dt * 2) {
					const i = (s._r() * s.hits.length) | 0;
					s.hits[i] = s.hits[i] > 0 ? 0 : s._r() * 0.5 + 0.4;
				}
				for (let i = 0; i < s.cols; i++)
					for (let j = 0; j < s.rows; j++) {
						const x = gx + i * cw,
							y = gy + j * ch;
						ctx.strokeStyle = W(0.08);
						ctx.strokeRect(x, y, cw - 3, ch - 3);
						const v = s.hits[j * s.cols + i];
						if (v > 0) {
							ctx.fillStyle = W(v * (0.7 + 0.3 * Math.sin(t * 3 + i + j)));
							ctx.fillRect(x, y, cw - 3, ch - 3);
						}
					}
				s.cur[0] = lerp(s.cur[0], s.tgt[0] + 0.5, clamp(dt * 3, 0, 1));
				s.cur[1] = lerp(s.cur[1], s.tgt[1] + 0.5, clamp(dt * 3, 0, 1));
				if (
					Math.abs(s.cur[0] - s.tgt[0] - 0.5) < 0.05 &&
					Math.abs(s.cur[1] - s.tgt[1] - 0.5) < 0.05
				) {
					s.lock += dt;
					if (s.lock > 1.1) {
						s.lock = 0;
						s.tgt = [(s._r() * s.cols) | 0, (s._r() * s.rows) | 0];
					}
				}
				const tx = gx + s.cur[0] * cw,
					ty = gy + s.cur[1] * ch;
				ctx.strokeStyle = W(0.85);
				ctx.lineWidth = 1.5;
				ctx.beginPath();
				ctx.moveTo(gx, ty);
				ctx.lineTo(gx + gw, ty);
				ctx.moveTo(tx, gy);
				ctx.lineTo(tx, gy + gh);
				ctx.stroke();
				ctx.beginPath();
				ctx.arc(tx, ty, 16, 0, TAU);
				ctx.stroke();
				if (s.lock > 0) {
					const rr = ease(clamp(s.lock / 0.5, 0, 1)) * 40;
					ctx.strokeStyle = W(clamp(1 - s.lock / 0.5, 0, 1) * 0.8);
					ctx.beginPath();
					ctx.arc(tx, ty, 16 + rr, 0, TAU);
					ctx.stroke();
				}
			},
		},
		'kyc-05': {
			// MONITORING — radar
			reset(s) {
				const r = s._r;
				s.blips = [];
				for (let i = 0; i < 9; i++)
					s.blips.push({ a: r() * TAU, rr: 0.15 + r() * 0.8, lit: 0 });
				s.beam = 0;
			},
			draw(ctx, w, h, t, dt, s) {
				const cx = w / 2,
					cy = h / 2,
					R = Math.min(w, h) * 0.42;
				ctx.strokeStyle = W(0.16);
				ctx.lineWidth = 1;
				for (let k = 1; k <= 4; k++) {
					ctx.beginPath();
					ctx.arc(cx, cy, (R * k) / 4, 0, TAU);
					ctx.stroke();
				}
				for (let a = 0; a < 12; a++) {
					const ang = (a * TAU) / 12;
					ctx.beginPath();
					ctx.moveTo(cx, cy);
					ctx.lineTo(cx + Math.cos(ang) * R, cy + Math.sin(ang) * R);
					ctx.stroke();
				}
				s.beam = (s.beam + dt * 0.9) % TAU;
				for (let i = 0; i < 28; i++) {
					const a0 = s.beam - i * 0.045;
					ctx.fillStyle = W(0.1 * (1 - i / 28));
					ctx.beginPath();
					ctx.moveTo(cx, cy);
					ctx.arc(cx, cy, R, a0 - 0.05, a0);
					ctx.closePath();
					ctx.fill();
				}
				ctx.strokeStyle = W(0.85);
				ctx.lineWidth = 1.5;
				ctx.beginPath();
				ctx.moveTo(cx, cy);
				ctx.lineTo(cx + Math.cos(s.beam) * R, cy + Math.sin(s.beam) * R);
				ctx.stroke();
				s.blips.forEach((b) => {
					const da = Math.abs(((s.beam - b.a + Math.PI) % TAU) - Math.PI);
					if (da < 0.08) b.lit = 1;
					b.lit = Math.max(0, b.lit - dt * 0.8);
					const bx = cx + Math.cos(b.a) * b.rr * R,
						by = cy + Math.sin(b.a) * b.rr * R;
					ctx.fillStyle = W(0.22 + b.lit * 0.7);
					const z = 2 + b.lit * 3;
					ctx.beginPath();
					ctx.arc(bx, by, z, 0, TAU);
					ctx.fill();
					if (b.lit > 0.3) {
						ctx.strokeStyle = W(b.lit * 0.6);
						ctx.beginPath();
						ctx.arc(bx, by, z + 4 + (1 - b.lit) * 5, 0, TAU);
						ctx.stroke();
					}
				});
				ctx.fillStyle = W(0.6 + 0.3 * Math.sin(t * 4));
				ctx.beginPath();
				ctx.arc(cx, cy, 3, 0, TAU);
				ctx.fill();
			},
		},
		setup: {
			// СТАРТ — country / OTP / custom intake
			reset(s) {
				s.otp = 0;
				s.tn = 0;
			},
			draw(ctx, w, h, t, dt, s) {
				const px = 0.1 * w,
					pw = 0.8 * w,
					py = 0.13 * h,
					ph = 0.72 * h,
					md = Math.min(w, h);
				ctx.strokeStyle = W(0.16);
				ctx.lineWidth = 1.5;
				ctx.strokeRect(px, py, pw, ph);
				const gx = px + pw * 0.2,
					gy = py + ph * 0.3,
					gr = md * 0.13;
				ctx.strokeStyle = W(0.2);
				ctx.lineWidth = 1;
				ctx.beginPath();
				ctx.arc(gx, gy, gr, 0, TAU);
				ctx.stroke();
				ctx.setLineDash([2, 5]);
				for (let k = 1; k <= 2; k++) {
					ctx.beginPath();
					ctx.ellipse(gx, gy, gr * (k / 3), gr, 0, 0, TAU);
					ctx.stroke();
					ctx.beginPath();
					ctx.ellipse(gx, gy, gr, gr * (k / 3), 0, 0, TAU);
					ctx.stroke();
				}
				ctx.setLineDash([]);
				const pa = t * 0.6,
					pinx = gx + Math.cos(pa) * gr * 0.7,
					piny = gy + Math.sin(pa * 0.6) * gr * 0.5;
				ctx.fillStyle = W(0.9);
				ctx.beginPath();
				ctx.arc(pinx, piny, 3, 0, TAU);
				ctx.fill();
				ctx.strokeStyle = W(0.5);
				ctx.beginPath();
				ctx.arc(pinx, piny, 4 + (1 + Math.sin(t * 4)) * 3, 0, TAU);
				ctx.stroke();
				const ox = px + pw * 0.46,
					oy = py + ph * 0.2,
					cs = Math.min(w * 0.045, 26),
					gap = cs * 0.4;
				s.tn += dt;
				if (s.tn > 0.5) {
					s.tn = 0;
					s.otp = (s.otp + 1) % 8;
				}
				for (let i = 0; i < 6; i++) {
					const x = ox + i * (cs + gap);
					ctx.strokeStyle = W(0.22);
					ctx.strokeRect(x, oy, cs, cs * 1.2);
					if (i < s.otp) {
						ctx.fillStyle = W(0.72);
						ctx.fillRect(x + cs * 0.3, oy + cs * 0.32, cs * 0.4, cs * 0.56);
					} else if (i === s.otp && Math.sin(t * 6) > 0) {
						ctx.fillStyle = W(0.5);
						ctx.fillRect(x + cs * 0.46, oy + cs * 0.25, 2, cs * 0.7);
					}
				}
				const fx = px + pw * 0.1,
					fw = pw * 0.8,
					fy = py + ph * 0.55;
				for (let r = 0; r < 3; r++) {
					const y = fy + r * ph * 0.135;
					ctx.strokeStyle = W(0.12);
					ctx.strokeRect(fx, y, fw, ph * 0.095);
					ctx.fillStyle = W(0.18);
					ctx.fillRect(fx + 8, y + ph * 0.032, fw * 0.18, ph * 0.03);
					if (r < 2) {
						ctx.fillStyle = W(0.1);
						ctx.fillRect(
							fx + fw * 0.3,
							y + ph * 0.032,
							fw * (0.3 + r * 0.18),
							ph * 0.03,
						);
					} else {
						const tw2 = fw * (0.25 + 0.18 * (0.5 + 0.5 * Math.sin(t * 0.8)));
						ctx.fillStyle = W(0.12);
						ctx.fillRect(fx + fw * 0.3, y + ph * 0.032, tw2, ph * 0.03);
						if (Math.sin(t * 5) > 0) {
							ctx.fillStyle = W(0.75);
							ctx.fillRect(
								fx + fw * 0.3 + tw2 + 3,
								y + ph * 0.022,
								2,
								ph * 0.05,
							);
						}
					}
					ctx.strokeStyle = W(0.2);
					ctx.strokeRect(
						fx + fw - ph * 0.075,
						y + ph * 0.02,
						ph * 0.055,
						ph * 0.055,
					);
					if (r === 0) {
						ctx.fillStyle = W(0.65);
						ctx.fillRect(
							fx + fw - ph * 0.065,
							y + ph * 0.03,
							ph * 0.035,
							ph * 0.035,
						);
					}
				}
			},
		},
		device: {
			// УСТРОЙСТВО — phone with fingerprint scan + signals
			reset(s) {
				const r = s._r;
				s.flags = [];
				for (let i = 0; i < 4; i++)
					s.flags.push({ on: r() < 0.5, nx: 0.5 + r() * 2.5 });
			},
			draw(ctx, w, h, t, dt, s) {
				const phw = Math.min(w * 0.26, h * 0.46),
					phh = phw * 1.95,
					pcx = w * 0.3,
					pcy = h * 0.5,
					px = pcx - phw / 2,
					py = pcy - phh / 2;
				rrect(ctx, px, py, phw, phh, phw * 0.16);
				ctx.strokeStyle = W(0.4);
				ctx.lineWidth = 1.6;
				ctx.stroke();
				rrect(
					ctx,
					px + phw * 0.07,
					py + phh * 0.05,
					phw * 0.86,
					phh * 0.9,
					phw * 0.1,
				);
				ctx.strokeStyle = W(0.12);
				ctx.lineWidth = 1;
				ctx.stroke();
				ctx.strokeStyle = W(0.3);
				ctx.lineWidth = 1.4;
				ctx.beginPath();
				ctx.moveTo(pcx - phw * 0.09, py + phh * 0.032);
				ctx.lineTo(pcx + phw * 0.09, py + phh * 0.032);
				ctx.stroke();
				const fcx = pcx,
					fcy = py + phh * 0.5,
					fr = phw * 0.32,
					phase = (t * 0.45) % 1.6,
					sweep = Math.min(phase, 1),
					scanning = phase < 1,
					scanY = fcy - fr + sweep * 2 * fr;
				const near0 = clamp(1 - Math.abs(scanY - fcy) / fr, 0, 1);
				for (let i = 1; i <= 7; i++) {
					const rr = (fr * i) / 7;
					ctx.strokeStyle = W(0.14 + (scanning ? near0 * 0.5 : 0.18));
					ctx.lineWidth = 1.3;
					ctx.beginPath();
					ctx.ellipse(
						fcx,
						fcy,
						rr * 0.86,
						rr,
						0,
						Math.PI * 0.5 + 0.62,
						Math.PI * 2.5 - 0.62,
						false,
					);
					ctx.stroke();
				}
				if (scanning) {
					ctx.strokeStyle = W(0.75);
					ctx.lineWidth = 1.3;
					ctx.beginPath();
					ctx.moveTo(fcx - fr, scanY);
					ctx.lineTo(fcx + fr, scanY);
					ctx.stroke();
				} else {
					const ok = clamp((phase - 1) * 3, 0, 1);
					ctx.strokeStyle = W(0.9 * ok);
					ctx.lineWidth = 2;
					ctx.beginPath();
					ctx.arc(fcx, fcy, fr * 0.55, -Math.PI / 2, -Math.PI / 2 + TAU * ok);
					ctx.stroke();
					if (ok > 0.7) {
						ctx.beginPath();
						ctx.moveTo(fcx - fr * 0.2, fcy);
						ctx.lineTo(fcx - fr * 0.04, fcy + fr * 0.18);
						ctx.lineTo(fcx + fr * 0.24, fcy - fr * 0.2);
						ctx.stroke();
					}
				}
				const fx = w * 0.62,
					fw = w * 0.3,
					fy = h * 0.22,
					rh = h * 0.15;
				s.flags.forEach((f, i) => {
					f.nx -= dt;
					if (f.nx <= 0) {
						f.nx = 0.8 + s._r() * 2.6;
						f.on = !f.on;
					}
					const y = fy + i * rh;
					ctx.strokeStyle = W(0.14);
					ctx.strokeRect(fx, y, fw, rh * 0.68);
					ctx.fillStyle = W(0.1);
					ctx.fillRect(fx + 12, y + rh * 0.27, fw * 0.42, rh * 0.15);
					const ix = fx + fw - 24,
						iy = y + rh * 0.34;
					if (f.on) {
						ctx.strokeStyle = W(0.85);
						ctx.lineWidth = 1.6;
						ctx.beginPath();
						ctx.moveTo(ix - 5, iy);
						ctx.lineTo(ix - 1, iy + 5);
						ctx.lineTo(ix + 7, iy - 6);
						ctx.stroke();
					} else {
						ctx.strokeStyle = W(0.5);
						ctx.lineWidth = 1.4;
						ctx.beginPath();
						ctx.moveTo(ix - 5, iy - 5);
						ctx.lineTo(ix + 6, iy + 6);
						ctx.moveTo(ix + 6, iy - 5);
						ctx.lineTo(ix - 5, iy + 6);
						ctx.stroke();
					}
				});
			},
		},
		card: {
			// КАРТА — PAN verification
			reset(s) {},
			draw(ctx, w, h, t, dt, s) {
				const cw = Math.min(w * 0.6, h * 1.05),
					ch = cw * 0.62,
					cx = w / 2 - cw / 2,
					cy = h / 2 - ch / 2;
				rrect(ctx, cx, cy, cw, ch, cw * 0.05);
				ctx.strokeStyle = W(0.32);
				ctx.lineWidth = 1.6;
				ctx.stroke();
				const chw = cw * 0.13,
					chh = chw * 0.74,
					chx = cx + cw * 0.09,
					chy = cy + ch * 0.22;
				rrect(ctx, chx, chy, chw, chh, 3);
				ctx.strokeStyle = W(0.5);
				ctx.lineWidth = 1.2;
				ctx.stroke();
				ctx.strokeStyle = W(0.3);
				ctx.beginPath();
				ctx.moveTo(chx, chy + chh / 2);
				ctx.lineTo(chx + chw, chy + chh / 2);
				ctx.moveTo(chx + chw / 2, chy);
				ctx.lineTo(chx + chw / 2, chy + chh);
				ctx.stroke();
				const wx = chx + chw + cw * 0.06,
					wy = chy + chh * 0.5;
				ctx.strokeStyle = W(0.35);
				for (let k = 1; k <= 3; k++) {
					ctx.beginPath();
					ctx.arc(wx, wy, k * cw * 0.018, -0.6, 0.6);
					ctx.stroke();
				}
				const phase = (t * 0.3) % 1.5,
					sweep = Math.min(phase, 1),
					scanning = phase < 1,
					scanX = cx + sweep * cw;
				const py = cy + ch * 0.56,
					dx = cx + cw * 0.09,
					dw = cw * 0.82,
					groups = 4,
					perG = 4,
					gGap = dw * 0.05,
					gW = (dw - gGap * (groups - 1)) / groups,
					cgap = gW * 0.12,
					cW = (gW - cgap * (perG - 1)) / perG;
				let idx = 0;
				for (let g = 0; g < groups; g++) {
					const gx = dx + g * (gW + gGap);
					for (let c = 0; c < perG; c++) {
						const x = gx + c * (cW + cgap),
							near = clamp(1 - Math.abs(x + cW / 2 - scanX) / 28, 0, 1);
						if (idx < 12) {
							ctx.fillStyle = W(0.3 + near * 0.45);
							ctx.beginPath();
							ctx.arc(
								x + cW / 2,
								py + cW * 0.5,
								Math.max(2, cW * 0.16),
								0,
								TAU,
							);
							ctx.fill();
						} else {
							ctx.fillStyle = W(0.6 + near * 0.35);
							ctx.fillRect(x + cW * 0.22, py, cW * 0.56, cW);
						}
						idx++;
					}
				}
				const binW = gW * 1.5 + gGap * 0.5;
				ctx.strokeStyle = W(0.4);
				ctx.lineWidth = 1.2;
				ctx.beginPath();
				ctx.moveTo(dx, py - cW * 0.55);
				ctx.lineTo(dx, py - cW * 0.85);
				ctx.lineTo(dx + binW, py - cW * 0.85);
				ctx.lineTo(dx + binW, py - cW * 0.55);
				ctx.stroke();
				ctx.fillStyle = W(0.18);
				ctx.fillRect(dx, cy + ch * 0.82, dw * 0.4, ch * 0.05);
				ctx.fillRect(dx + dw * 0.7, cy + ch * 0.82, dw * 0.3, ch * 0.05);
				if (scanning) {
					ctx.strokeStyle = W(0.6);
					ctx.lineWidth = 1.2;
					ctx.beginPath();
					ctx.moveTo(scanX, cy);
					ctx.lineTo(scanX, cy + ch);
					ctx.stroke();
				} else {
					const ok = clamp((phase - 1) * 3, 0, 1),
						tx = cx + cw * 0.86,
						ty = cy + ch * 0.2,
						rad = cw * 0.05;
					ctx.strokeStyle = W(0.9 * ok);
					ctx.lineWidth = 2;
					ctx.beginPath();
					ctx.arc(tx, ty, rad, -Math.PI / 2, -Math.PI / 2 + TAU * ok);
					ctx.stroke();
					if (ok > 0.7) {
						ctx.beginPath();
						ctx.moveTo(tx - rad * 0.4, ty);
						ctx.lineTo(tx - rad * 0.1, ty + rad * 0.4);
						ctx.lineTo(tx + rad * 0.5, ty - rad * 0.4);
						ctx.stroke();
					}
				}
			},
		},
		hybrid: {
			// ГИБРИД — director (person) linked to company graph
			reset(s) {
				s.fm = faceModel();
				s.intro = 0;
			},
			draw(ctx, w, h, t, dt, s) {
				s.intro = clamp(s.intro + dt / 1.1, 0, 1);
				const pcx = w * 0.22,
					pcy = h * 0.5,
					pS = Math.min(w * 0.12, h * 0.2);
				const A = 0.22 * Math.sin(t * 0.5),
					cA = Math.cos(A),
					sA = Math.sin(A);
				const raw = s.fm.pts.map((p) => {
					const x = p.x * cA + p.z * sA,
						z = -p.x * sA + p.z * cA,
						pe = 1 / (1 - z * 0.3);
					return { x: x * pe, y: p.y * pe, z: z };
				});
				let mnx = 1e9,
					mxx = -1e9,
					mny = 1e9,
					mxy = -1e9;
				raw.forEach((p) => {
					if (p.x < mnx) mnx = p.x;
					if (p.x > mxx) mxx = p.x;
					if (p.y < mny) mny = p.y;
					if (p.y > mxy) mxy = p.y;
				});
				const fS = Math.min(
						(pS * 1.5) / (mxx - mnx || 1),
						(pS * 1.8) / (mxy - mny || 1),
					),
					ox = pcx - ((mnx + mxx) / 2) * fS,
					oy = pcy + ((mny + mxy) / 2) * fS;
				const fpj = raw.map((p) => ({
					sx: ox + p.x * fS,
					sy: oy - p.y * fS,
					z: p.z,
				}));
				for (let e = 0; e < s.fm.edges.length; e++) {
					const P = fpj[s.fm.edges[e][0]],
						Q = fpj[s.fm.edges[e][1]];
					ctx.strokeStyle = W(clamp(0.14 + (P.z + Q.z) * 0.4, 0.06, 0.42));
					ctx.lineWidth = 1;
					ctx.beginPath();
					ctx.moveTo(P.sx, P.sy);
					ctx.lineTo(Q.sx, Q.sy);
					ctx.stroke();
				}
				ctx.fillStyle = W(0.55);
				fpj.forEach((P) => ctx.fillRect(P.sx - 1, P.sy - 1, 2, 2));
				ctx.strokeStyle = W(0.3);
				ctx.lineWidth = 1.2;
				ctx.strokeRect(pcx - pS * 0.98, pcy - pS * 1.3, pS * 1.96, pS * 2.6);
				const comp = { x: w * 0.62, y: h * 0.3 },
					leaves = [
						{ x: w * 0.54, y: h * 0.72 },
						{ x: w * 0.7, y: h * 0.72 },
						{ x: w * 0.84, y: h * 0.64 },
					];
				const lx0 = pcx + pS * 1.0,
					ly0 = pcy;
				ctx.strokeStyle = W(0.3);
				ctx.lineWidth = 1.2;
				ctx.beginPath();
				ctx.moveTo(lx0, ly0);
				ctx.lineTo(comp.x, comp.y);
				ctx.stroke();
				if (s.intro > 0.4) {
					const pp = (t * 0.6) % 1;
					ctx.fillStyle = W(0.9);
					ctx.beginPath();
					ctx.arc(lerp(lx0, comp.x, pp), lerp(ly0, comp.y, pp), 2.6, 0, TAU);
					ctx.fill();
				}
				ctx.strokeStyle = W(0.26);
				leaves.forEach((L) => {
					ctx.beginPath();
					ctx.moveTo(comp.x, comp.y);
					ctx.lineTo(
						lerp(comp.x, L.x, ease(s.intro)),
						lerp(comp.y, L.y, ease(s.intro)),
					);
					ctx.stroke();
				});
				ctx.fillStyle = '#0a0a0b';
				ctx.strokeStyle = W(0.85);
				ctx.lineWidth = 1.6;
				const cs = 12;
				ctx.fillRect(comp.x - cs, comp.y - cs, cs * 2, cs * 2);
				ctx.strokeRect(comp.x - cs, comp.y - cs, cs * 2, cs * 2);
				ctx.fillStyle = W(0.9);
				ctx.fillRect(comp.x - 3, comp.y - 3, 6, 6);
				leaves.forEach((L) => {
					ctx.fillStyle = '#0a0a0b';
					ctx.strokeStyle = W(0.8);
					ctx.lineWidth = 1.4;
					ctx.beginPath();
					ctx.arc(L.x, L.y, 7, 0, TAU);
					ctx.fill();
					ctx.stroke();
				});
			},
		},
		'kyb-01': {
			// REGISTRY — scrolling ledger
			reset(s) {
				const r = s._r;
				s.rows = [];
				for (let i = 0; i < 16; i++)
					s.rows.push({
						f: [0.13, 0.2, 0.16, 0.22, 0.12].map((fw) => ({
							fw,
							w: 0.5 + r() * 0.5,
							on: r() < 0.85,
						})),
						hl: r() < 0.18,
					});
				s.off = 0;
			},
			draw(ctx, w, h, t, dt, s) {
				const gx = 0.1 * w,
					gy = 0.1 * h,
					gw = 0.8 * w,
					gh = 0.72 * h,
					rh = gh / 11;
				s.off += dt * 0.35;
				ctx.save();
				ctx.beginPath();
				ctx.rect(gx, gy, gw, gh);
				ctx.clip();
				for (let k = -1; k < 12; k++) {
					const ri =
						((((s.off | 0) + k) % s.rows.length) + s.rows.length) %
						s.rows.length;
					const row = s.rows[ri];
					const y = gy + (k - (s.off % 1)) * rh + rh * 0.5;
					ctx.strokeStyle = W(0.08);
					ctx.beginPath();
					ctx.moveTo(gx, y + rh * 0.5);
					ctx.lineTo(gx + gw, y + rh * 0.5);
					ctx.stroke();
					let x = gx + 12;
					row.f.forEach((f) => {
						if (f.on) {
							ctx.fillStyle = W(0.1 + (row.hl ? 0.12 : 0.04));
							ctx.fillRect(x, y + rh * 0.2, f.fw * gw * f.w, rh * 0.3);
						}
						x += f.fw * gw + 8;
					});
					if (row.hl) {
						ctx.fillStyle = W(0.8);
						ctx.fillRect(gx, y + rh * 0.1, 4, rh * 0.55);
					}
				}
				ctx.restore();
				const by = gy + gh * 0.5,
					g = ctx.createLinearGradient(0, by - rh, 0, by + rh);
				g.addColorStop(0, W(0));
				g.addColorStop(0.5, W(0.1));
				g.addColorStop(1, W(0));
				ctx.fillStyle = g;
				ctx.fillRect(gx, by - rh, gw, rh * 2);
				ctx.strokeStyle = W(0.6);
				ctx.lineWidth = 1;
				ctx.beginPath();
				ctx.moveTo(gx, by);
				ctx.lineTo(gx + gw, by);
				ctx.stroke();
				ctx.strokeStyle = W(0.85);
				ctx.lineWidth = 2;
				const ck = gx + gw - 26;
				ctx.beginPath();
				ctx.moveTo(ck - 6, by);
				ctx.lineTo(ck - 1, by + 6);
				ctx.lineTo(ck + 8, by - 7);
				ctx.stroke();
			},
		},
		'kyb-02': {
			// OWNERSHIP — graph with flow pulses
			reset(s) {
				const r = s._r;
				const root = { x: 0.5, y: 0.17 };
				const l1 = [];
				for (let i = 0; i < 3; i++) l1.push({ x: 0.27 + i * 0.23, y: 0.47 });
				const leaves = [],
					edges = [];
				l1.forEach((p) => {
					edges.push([root, p]);
					const k = 1 + ((r() * 3) | 0);
					for (let c = 0; c < k; c++) {
						const lf = {
							x: clamp(
								p.x + (c - (k - 1) / 2) * 0.09 + (r() * 2 - 1) * 0.02,
								0.08,
								0.92,
							),
							y: 0.8 + (r() * 2 - 1) * 0.03,
						};
						leaves.push(lf);
						edges.push([p, lf]);
					}
				});
				s.root = root;
				s.edges = edges;
				s.nodes = [root].concat(l1, leaves);
				s.ubo = leaves[leaves.length - 1];
				s.intro = 0;
			},
			draw(ctx, w, h, t, dt, s) {
				s.intro = clamp(s.intro + dt / 1.2, 0, 1);
				const X = (p) => p.x * w,
					Y = (p) => p.y * h,
					e = ease(s.intro);
				ctx.strokeStyle = W(0.28);
				ctx.lineWidth = 1.2;
				s.edges.forEach(([a, b]) => {
					ctx.beginPath();
					ctx.moveTo(X(a), Y(a));
					ctx.lineTo(lerp(X(a), X(b), e), lerp(Y(a), Y(b), e));
					ctx.stroke();
				});
				if (s.intro > 0.9) {
					const ph = (t * 0.5) % 1;
					s.edges.forEach(([a, b]) => {
						const fr =
							a === s.root ? clamp(ph * 2, 0, 1) : clamp(ph * 2 - 1, 0, 1);
						if (fr > 0 && fr < 1) {
							ctx.fillStyle = W(0.9);
							ctx.beginPath();
							ctx.arc(lerp(X(a), X(b), fr), lerp(Y(a), Y(b), fr), 2.6, 0, TAU);
							ctx.fill();
						}
					});
				}
				s.nodes.forEach((n) => {
					const root = n === s.root,
						pz = 1 + 0.12 * Math.sin(t * 2 + n.x * 6),
						rad = (root ? 14 : 8) * pz * (0.5 + 0.5 * s.intro);
					ctx.fillStyle = '#0a0a0b';
					ctx.strokeStyle = W(0.82);
					ctx.lineWidth = 1.5;
					ctx.beginPath();
					ctx.arc(X(n), Y(n), rad, 0, TAU);
					ctx.fill();
					ctx.stroke();
					if (root) {
						ctx.fillStyle = W(0.9);
						ctx.beginPath();
						ctx.arc(X(n), Y(n), 4, 0, TAU);
						ctx.fill();
					}
				});
				if (s.intro > 0.95) {
					const pr = (t * 0.6) % 1;
					ctx.strokeStyle = W((1 - pr) * 0.8);
					ctx.lineWidth = 1.5;
					ctx.beginPath();
					ctx.arc(X(s.ubo), Y(s.ubo), 10 + pr * 22, 0, TAU);
					ctx.stroke();
					ctx.setLineDash([2, 4]);
					ctx.strokeStyle = W(0.7);
					ctx.beginPath();
					ctx.arc(X(s.ubo), Y(s.ubo), 16, 0, TAU);
					ctx.stroke();
					ctx.setLineDash([]);
				}
			},
		},
		'kyb-03': {
			// SCREENING — hatch + reticle hops
			reset(s) {
				const r = s._r;
				s.flags = [];
				for (let i = 0; i < 5; i++)
					s.flags.push({ x: 0.18 + r() * 0.64, y: 0.2 + r() * 0.6 });
				s.cur = { x: 0.5, y: 0.5 };
				s.ti = 0;
				s.lock = 0;
			},
			draw(ctx, w, h, t, dt, s) {
				const off = (t * 8) % 22;
				ctx.strokeStyle = W(0.05);
				ctx.lineWidth = 1;
				for (let d = -h + off; d < w; d += 22) {
					ctx.beginPath();
					ctx.moveTo(d, 0);
					ctx.lineTo(d + h, h);
					ctx.stroke();
				}
				s.flags.forEach((f) => {
					ctx.strokeStyle = W(0.5);
					ctx.lineWidth = 1.2;
					ctx.strokeRect(f.x * w - 13, f.y * h - 13, 26, 26);
				});
				const tg = s.flags[s.ti];
				s.cur.x = lerp(s.cur.x, tg.x, clamp(dt * 2.5, 0, 1));
				s.cur.y = lerp(s.cur.y, tg.y, clamp(dt * 2.5, 0, 1));
				if (
					Math.abs(s.cur.x - tg.x) < 0.005 &&
					Math.abs(s.cur.y - tg.y) < 0.005
				) {
					s.lock += dt;
					if (s.lock > 1) {
						s.lock = 0;
						s.ti = (s.ti + 1) % s.flags.length;
					}
				}
				const rx = s.cur.x * w,
					ry = s.cur.y * h,
					bl = 14 + (s.lock > 0 ? ease(clamp(s.lock / 0.4, 0, 1)) * 4 : 0);
				ctx.strokeStyle = W(0.9);
				ctx.lineWidth = 1.6;
				[
					[-1, -1],
					[1, -1],
					[-1, 1],
					[1, 1],
				].forEach(([sx, sy]) => {
					ctx.beginPath();
					ctx.moveTo(rx + sx * bl, ry + sy * bl - sy * 7);
					ctx.lineTo(rx + sx * bl, ry + sy * bl);
					ctx.lineTo(rx + sx * bl - sx * 7, ry + sy * bl);
					ctx.stroke();
				});
				ctx.save();
				ctx.translate(w / 2, h / 2);
				ctx.rotate(t * 0.3);
				ctx.strokeStyle = W(0.4);
				ctx.beginPath();
				ctx.arc(0, 0, 60, 0, TAU);
				ctx.stroke();
				for (let a = 0; a < 8; a++) {
					const ang = (a * TAU) / 8;
					ctx.beginPath();
					ctx.moveTo(Math.cos(ang) * 60, Math.sin(ang) * 60);
					ctx.lineTo(Math.cos(ang) * 70, Math.sin(ang) * 70);
					ctx.stroke();
				}
				ctx.restore();
				ctx.strokeStyle = W(0.5);
				ctx.lineWidth = 1;
				ctx.beginPath();
				ctx.moveTo(w / 2 - 86, h / 2);
				ctx.lineTo(w / 2 + 86, h / 2);
				ctx.moveTo(w / 2, h / 2 - 86);
				ctx.lineTo(w / 2, h / 2 + 86);
				ctx.stroke();
			},
		},
		'kyb-04': {
			// RISK — living heatmap
			reset(s) {
				s.cols = 14;
				s.rows = 9;
			},
			draw(ctx, w, h, t, dt, s) {
				const gx = 0.14 * w,
					gy = 0.13 * h,
					gw = 0.72 * w,
					gh = 0.7 * h,
					cw = gw / s.cols,
					ch = gh / s.rows;
				const hx = (0.5 + 0.4 * Math.sin(t * 0.5)) * s.cols,
					hy = (0.5 + 0.4 * Math.cos(t * 0.37)) * s.rows;
				let best = 0,
					bi = 0,
					bj = 0;
				for (let i = 0; i < s.cols; i++)
					for (let j = 0; j < s.rows; j++) {
						const v = clamp(1 - Math.hypot(i - hx, j - hy) / 7, 0, 1);
						if (v > best) {
							best = v;
							bi = i;
							bj = j;
						}
						ctx.fillStyle = W(0.05 + v * 0.75);
						ctx.fillRect(gx + i * cw + 1, gy + j * ch + 1, cw - 2, ch - 2);
					}
				const bx = gx + bi * cw,
					by = gy + bj * ch,
					e = 3 + Math.sin(t * 4) * 1.5;
				ctx.strokeStyle = W(0.92);
				ctx.lineWidth = 2;
				ctx.strokeRect(bx - e, by - e, cw + e * 2, ch + e * 2);
				ctx.strokeStyle = W(0.18);
				ctx.lineWidth = 1;
				for (let i = 0; i <= s.cols; i++) {
					ctx.beginPath();
					ctx.moveTo(gx + i * cw, gy + gh + 6);
					ctx.lineTo(gx + i * cw, gy + gh + 12);
					ctx.stroke();
				}
			},
		},
		'kyb-05': {
			// MONITORING — scrolling waveform
			reset(s) {
				const r = s._r;
				s.N = 140;
				s.buf = [];
				for (let i = 0; i < s.N; i++) s.buf.push(0.1 + r() * 0.1);
				s.acc = 0;
				s.alerts = [];
				s.nx = 60 + r() * 120;
			},
			draw(ctx, w, h, t, dt, s) {
				const mid = h / 2;
				s.acc += dt * 60;
				while (s.acc >= 1) {
					s.acc -= 1;
					let v =
						0.12 +
						Math.abs(Math.sin(t * 6 + s.buf.length)) * 0.06 +
						s._r() * 0.08;
					s.nx -= 1;
					let al = false;
					if (s.nx <= 0) {
						s.nx = 70 + s._r() * 150;
						v = 0.5 + s._r() * 0.4;
						al = true;
					}
					s.buf.push(v);
					if (s.buf.length > s.N) s.buf.shift();
					s.alerts.forEach((a) => a.i--);
					if (al) s.alerts.push({ i: s.N - 1 });
					s.alerts = s.alerts.filter((a) => a.i > 0);
				}
				const bw = w / s.N;
				ctx.strokeStyle = W(0.12);
				ctx.beginPath();
				ctx.moveTo(0, mid);
				ctx.lineTo(w, mid);
				ctx.stroke();
				for (let i = 0; i < s.buf.length; i++) {
					const hh = s.buf[i] * h;
					ctx.fillStyle = W(0.25 + s.buf[i] * 0.5);
					ctx.fillRect(i * bw + bw * 0.2, mid - hh, bw * 0.55, hh * 2);
				}
				s.alerts.forEach((a) => {
					const x = a.i * bw;
					ctx.setLineDash([3, 4]);
					ctx.strokeStyle = W(0.7);
					ctx.beginPath();
					ctx.moveTo(x, 30);
					ctx.lineTo(x, h - 30);
					ctx.stroke();
					ctx.setLineDash([]);
					ctx.fillStyle = W(0.95);
					ctx.beginPath();
					ctx.arc(x, mid, 4, 0, TAU);
					ctx.fill();
				});
				const to = (t * 30) % (w / 10);
				ctx.strokeStyle = W(0.2);
				for (let i = -1; i <= 10; i++) {
					const x = i * (w / 10) + w / 10 - to;
					ctx.beginPath();
					ctx.moveTo(x, h - 26);
					ctx.lineTo(x, h - 16);
					ctx.stroke();
				}
			},
		},
		'auth-login': {
			// ВХОД — authentication gate (lock + scan)
			reset(s) {},
			draw(ctx, w, h, t, dt, s) {
				const cx = w / 2,
					cy = h * 0.46,
					R = Math.min(w, h) * 0.3;
				ctx.strokeStyle = W(0.16);
				ctx.lineWidth = 1;
				for (let i = 0; i < 48; i++) {
					const a = (i * TAU) / 48,
						r1 = R * 1.2,
						r2 = R * 1.2 + (i % 4 === 0 ? 8 : 4);
					ctx.beginPath();
					ctx.moveTo(cx + Math.cos(a) * r1, cy + Math.sin(a) * r1);
					ctx.lineTo(cx + Math.cos(a) * r2, cy + Math.sin(a) * r2);
					ctx.stroke();
				}
				ctx.setLineDash([4, 8]);
				ctx.save();
				ctx.translate(cx, cy);
				ctx.rotate(t * 0.3);
				ctx.strokeStyle = W(0.24);
				ctx.beginPath();
				ctx.arc(0, 0, R, 0, TAU);
				ctx.stroke();
				ctx.restore();
				ctx.save();
				ctx.translate(cx, cy);
				ctx.rotate(-t * 0.22);
				ctx.strokeStyle = W(0.16);
				ctx.beginPath();
				ctx.arc(0, 0, R * 0.74, 0, TAU);
				ctx.stroke();
				ctx.restore();
				ctx.setLineDash([]);
				for (let i = 0; i < 3; i++) {
					const a = t * 0.8 + (i * TAU) / 3,
						x = cx + Math.cos(a) * R,
						y = cy + Math.sin(a) * R;
					ctx.fillStyle = W(0.8);
					ctx.beginPath();
					ctx.arc(x, y, 2.4, 0, TAU);
					ctx.fill();
				}
				const cyc = (t * 0.3) % 1,
					open = clamp((cyc - 0.62) / 0.22, 0, 1);
				const bw = R * 0.52,
					bh = R * 0.44,
					bx = cx - bw / 2,
					by = cy - bh * 0.05;
				ctx.strokeStyle = W(0.75);
				ctx.lineWidth = 2;
				rrect(ctx, bx, by, bw, bh, 5);
				ctx.stroke();
				ctx.save();
				ctx.translate(cx, by);
				ctx.rotate(open * 0.5);
				ctx.translate(0, -open * bh * 0.3);
				ctx.strokeStyle = W(0.6);
				ctx.lineWidth = 2;
				ctx.beginPath();
				ctx.arc(0, 0, bw * 0.3, Math.PI * 1.04, Math.PI * 1.96, false);
				ctx.stroke();
				ctx.restore();
				ctx.fillStyle = W(0.8);
				ctx.beginPath();
				ctx.arc(cx, by + bh * 0.42, 3.2, 0, TAU);
				ctx.fill();
				ctx.fillRect(cx - 1.4, by + bh * 0.42, 2.8, bh * 0.28);
				const sp = (t * 0.5) % 1,
					scanY = cy - R + sp * 2 * R;
				ctx.strokeStyle = W(0.45);
				ctx.lineWidth = 1.2;
				ctx.beginPath();
				ctx.moveTo(cx - R, scanY);
				ctx.lineTo(cx + R, scanY);
				ctx.stroke();
				if (open > 0.15) {
					const gy = cy + R * 1.55;
					ctx.strokeStyle = W(0.9 * open);
					ctx.lineWidth = 2;
					ctx.beginPath();
					ctx.arc(cx, gy, R * 0.16, -Math.PI / 2, -Math.PI / 2 + TAU * open);
					ctx.stroke();
					if (open > 0.7) {
						ctx.beginPath();
						ctx.moveTo(cx - R * 0.06, gy);
						ctx.lineTo(cx - R * 0.01, gy + R * 0.05);
						ctx.lineTo(cx + R * 0.08, gy - R * 0.06);
						ctx.stroke();
					}
				}
			},
		},
		'auth-register': {
			// РЕГИСТРАЦИЯ — identity assembly
			reset(s) {
				const r = s._r;
				s.parts = [];
				for (let i = 0; i < 28; i++)
					s.parts.push({ a: r() * TAU, d: 0.9 + r() * 0.7, ph: r() * TAU });
				s.nodes = [];
				for (let i = 0; i < 4; i++) s.nodes.push({ a: (i / 4) * TAU + 0.5 });
			},
			draw(ctx, w, h, t, dt, s) {
				const cx = w / 2,
					cy = h * 0.5,
					R = Math.min(w, h) * 0.32;
				const cyc = (t * 0.26) % 1,
					assemble = ease(clamp(cyc / 0.55, 0, 1)),
					grow = clamp((cyc - 0.55) / 0.32, 0, 1);
				s.parts.forEach((p) => {
					const fx = cx + Math.cos(p.a) * R * p.d * 1.9,
						fy = cy + Math.sin(p.a) * R * p.d * 1.9,
						x = lerp(fx, cx + Math.cos(p.ph + t) * 6, assemble),
						y = lerp(fy, cy + Math.sin(p.ph + t) * 6, assemble);
					if (assemble < 0.96) {
						ctx.strokeStyle = W(0.07 * (1 - assemble));
						ctx.lineWidth = 1;
						ctx.beginPath();
						ctx.moveTo(fx, fy);
						ctx.lineTo(x, y);
						ctx.stroke();
					}
					ctx.fillStyle = W(0.3 + assemble * 0.5);
					ctx.fillRect(x - 1, y - 1, 2.2, 2.2);
				});
				ctx.strokeStyle = W(0.6);
				ctx.lineWidth = 1.6;
				ctx.beginPath();
				ctx.arc(cx, cy, R * 0.22 * assemble, 0, TAU);
				ctx.stroke();
				s.nodes.forEach((n) => {
					const x = cx + Math.cos(n.a) * R * 0.62 * grow,
						y = cy + Math.sin(n.a) * R * 0.62 * grow;
					ctx.strokeStyle = W(0.25 * grow);
					ctx.lineWidth = 1;
					ctx.beginPath();
					ctx.moveTo(cx, cy);
					ctx.lineTo(x, y);
					ctx.stroke();
					ctx.fillStyle = '#0a0a0b';
					ctx.strokeStyle = W(0.8 * grow);
					ctx.lineWidth = 1.4;
					ctx.beginPath();
					ctx.arc(x, y, 5, 0, TAU);
					ctx.fill();
					ctx.stroke();
				});
				if (assemble > 0.8) {
					const a = (assemble - 0.8) / 0.2;
					ctx.strokeStyle = W(0.9 * a);
					ctx.lineWidth = 2;
					ctx.beginPath();
					ctx.moveTo(cx - 6, cy);
					ctx.lineTo(cx + 6, cy);
					ctx.moveTo(cx, cy - 6);
					ctx.lineTo(cx, cy + 6);
					ctx.stroke();
				}
				ctx.setLineDash([3, 7]);
				ctx.save();
				ctx.translate(cx, cy);
				ctx.rotate(t * 0.2);
				ctx.strokeStyle = W(0.13);
				ctx.beginPath();
				ctx.arc(0, 0, R * 1.08, 0, TAU);
				ctx.stroke();
				ctx.restore();
				ctx.setLineDash([]);
			},
		},
		'biz-tree': {
			// KYB — ownership tree discovery
			reset(s) {
				s.nodes = [
					{ x: 0.5, y: 0.16, app: 0, root: true },
					{ x: 0.22, y: 0.48, app: 0.16 },
					{ x: 0.5, y: 0.48, app: 0.26 },
					{ x: 0.78, y: 0.48, app: 0.36 },
					{ x: 0.13, y: 0.82, app: 0.58 },
					{ x: 0.31, y: 0.82, app: 0.66 },
					{ x: 0.69, y: 0.82, app: 0.72 },
					{ x: 0.87, y: 0.82, app: 0.8 },
				];
				s.edges = [
					[0, 1, '100%'],
					[0, 2, '40%'],
					[0, 3, '60%'],
					[1, 4, '55%'],
					[1, 5, '45%'],
					[3, 6, '70%'],
					[3, 7, '30%'],
				];
			},
			draw(ctx, w, h, t, dt, s) {
				const cyc = (t * 0.14) % 1,
					p = ease(clamp(cyc / 0.82, 0, 1));
				const padX = w * 0.1,
					padY = h * 0.12,
					bw = Math.min(w * 0.135, 70),
					bh = Math.min(h * 0.13, 40);
				const PX = (n) => padX + n.x * (w - 2 * padX),
					PY = (n) => padY + n.y * (h - 2 * padY);
				const scanY = padY + ((t * 0.22) % 1) * (h - 2 * padY);
				const pos = s.nodes.map((n) => ({
					x: PX(n),
					y: PY(n),
					app: n.app,
					root: n.root,
				}));
				const curIdx = Math.floor((t * 0.5) % s.nodes.length);
				ctx.font = "9px 'JetBrains Mono', monospace";
				ctx.textAlign = 'center';
				s.edges.forEach((e) => {
					const A = pos[e[0]],
						B = pos[e[1]],
						ax = A.x,
						ay = A.y + bh / 2,
						bx = B.x,
						by = B.y - bh / 2,
						my = (ay + by) / 2;
					const rev = clamp((p - Math.max(A.app, B.app)) / 0.1, 0, 1);
					if (rev <= 0) return;
					ctx.globalAlpha = rev;
					ctx.strokeStyle = W(0.22);
					ctx.lineWidth = 1;
					ctx.beginPath();
					ctx.moveTo(ax, ay);
					ctx.lineTo(ax, my);
					ctx.lineTo(bx, my);
					ctx.lineTo(bx, by);
					ctx.stroke();
					const q = (t * 0.4 + e[0] * 0.2) % 1;
					let pxp, pyp;
					if (q < 0.34) {
						pxp = ax;
						pyp = lerp(ay, my, q / 0.34);
					} else if (q < 0.66) {
						pxp = lerp(ax, bx, (q - 0.34) / 0.32);
						pyp = my;
					} else {
						pxp = bx;
						pyp = lerp(my, by, (q - 0.66) / 0.34);
					}
					ctx.fillStyle = W(0.8);
					ctx.beginPath();
					ctx.arc(pxp, pyp, 1.8, 0, TAU);
					ctx.fill();
					if (rev > 0.6) {
						ctx.fillStyle = W(0.5);
						ctx.fillText(e[2], (ax + bx) / 2, my - 4);
					}
					ctx.globalAlpha = 1;
				});
				pos.forEach((n, i) => {
					const ns = clamp((p - n.app) / 0.09, 0, 1);
					if (ns <= 0) return;
					const cw = bw * ns,
						ch = bh * ns,
						x = n.x - cw / 2,
						y = n.y - ch / 2;
					const near = clamp(1 - Math.abs(n.y - scanY) / (bh * 1.2), 0, 1),
						isCur = i === curIdx;
					ctx.fillStyle = '#0a0a0b';
					ctx.strokeStyle = W(
						(n.root ? 0.9 : 0.5) + near * 0.35 + (isCur ? 0.2 : 0),
					);
					ctx.lineWidth = n.root || isCur ? 1.8 : 1.2;
					rrect(ctx, x, y, cw, ch, 2);
					ctx.fill();
					ctx.stroke();
					if (ns > 0.7) {
						ctx.fillStyle = W(0.32 + near * 0.4);
						ctx.fillRect(x + 6, y + 7, cw * 0.42, 3);
						ctx.fillStyle = W(0.16);
						ctx.fillRect(x + 6, y + ch - 13, cw * 0.66, 2);
						ctx.fillRect(x + 6, y + ch - 9, cw * 0.4, 2);
						if (n.root) {
							ctx.fillStyle = W(0.9);
							ctx.beginPath();
							ctx.arc(x + cw - 9, y + 9, 2.4, 0, TAU);
							ctx.fill();
						}
					}
					if (isCur && ns > 0.8) {
						ctx.strokeStyle = W(0.85);
						ctx.lineWidth = 1.3;
						const tl = 6,
							o = 3;
						[
							[x - o, y - o, 1, 1],
							[x + cw + o, y - o, -1, 1],
							[x - o, y + ch + o, 1, -1],
							[x + cw + o, y + ch + o, -1, -1],
						].forEach((c) => {
							ctx.beginPath();
							ctx.moveTo(c[0], c[1] + c[3] * tl);
							ctx.lineTo(c[0], c[1]);
							ctx.lineTo(c[0] + c[2] * tl, c[1]);
							ctx.stroke();
						});
					}
				});
				ctx.textAlign = 'start';
			},
		},
		crypto: {
			// AML CRYPTO — blockchain transaction graph
			reset(s) {
				const r = s._r;
				s.nodes = [{ x: 0, y: 0, sub: true }];
				const N = 7;
				for (let i = 0; i < N; i++) {
					const a = (i / N) * TAU + 0.3,
						rad = 0.6 + r() * 0.26;
					s.nodes.push({
						x: Math.cos(a) * rad,
						y: Math.sin(a) * rad * 0.84,
						flag: i === 2,
					});
				}
				s.edges = [];
				for (let i = 1; i < s.nodes.length; i++)
					if (r() < 0.82)
						s.edges.push({ a: 0, b: i, dir: r() < 0.5 ? 1 : -1, ph: r() });
				for (let k = 0; k < 5; k++) {
					const a = 1 + Math.floor(r() * N),
						b = 1 + Math.floor(r() * N);
					if (a !== b) s.edges.push({ a, b, dir: 1, ph: r() });
				}
			},
			draw(ctx, w, h, t, dt, s) {
				const cx = w / 2,
					cy = h * 0.5,
					S = Math.min(w * 0.4, h * 0.46);
				const P = s.nodes.map((n) => ({
					x: cx + n.x * S,
					y: cy + n.y * S,
					sub: n.sub,
					flag: n.flag,
				}));
				s.edges.forEach((e) => {
					const A = P[e.a],
						B = P[e.b];
					ctx.strokeStyle = W(0.16);
					ctx.lineWidth = 1;
					ctx.beginPath();
					ctx.moveTo(A.x, A.y);
					ctx.lineTo(B.x, B.y);
					ctx.stroke();
					const pp = (((t * 0.4 * e.dir + e.ph) % 1) + 1) % 1,
						px = lerp(A.x, B.x, pp),
						py = lerp(A.y, B.y, pp);
					ctx.fillStyle = W(0.85);
					ctx.beginPath();
					ctx.arc(px, py, 2, 0, TAU);
					ctx.fill();
				});
				const hex = (x, y, rad) => {
					ctx.beginPath();
					for (let k = 0; k < 6; k++) {
						const a = (k / 6) * TAU + Math.PI / 6,
							hx = x + Math.cos(a) * rad,
							hy = y + Math.sin(a) * rad;
						k ? ctx.lineTo(hx, hy) : ctx.moveTo(hx, hy);
					}
					ctx.closePath();
				};
				P.forEach((n) => {
					if (n.flag) {
						const pr2 = (t * 0.5) % 1;
						ctx.strokeStyle = W(0.5 * (1 - pr2));
						ctx.lineWidth = 1.4;
						ctx.beginPath();
						ctx.arc(n.x, n.y, 9 + pr2 * 15, 0, TAU);
						ctx.stroke();
					}
					const rad = n.sub ? 10 : 6;
					ctx.fillStyle = '#0a0a0b';
					ctx.strokeStyle = W(n.flag ? 0.95 : n.sub ? 0.9 : 0.55);
					ctx.lineWidth = n.sub ? 2 : 1.4;
					hex(n.x, n.y, rad);
					ctx.fill();
					ctx.stroke();
					if (n.flag) {
						ctx.fillStyle = W(0.95);
						ctx.fillRect(n.x - 1, n.y - 4, 2, 5);
						ctx.fillRect(n.x - 1, n.y + 3, 2, 2);
					}
					if (n.sub) {
						ctx.fillStyle = W(0.9);
						ctx.beginPath();
						ctx.arc(n.x, n.y, 2.6, 0, TAU);
						ctx.fill();
					}
				});
				const ang = t * 0.8;
				ctx.setLineDash([3, 6]);
				ctx.strokeStyle = W(0.26);
				ctx.lineWidth = 1;
				ctx.beginPath();
				ctx.arc(cx, cy, S * 0.3, 0, TAU);
				ctx.stroke();
				ctx.setLineDash([]);
				ctx.strokeStyle = W(0.5);
				ctx.lineWidth = 1.2;
				ctx.beginPath();
				ctx.moveTo(cx, cy);
				ctx.lineTo(cx + Math.cos(ang) * S * 0.3, cy + Math.sin(ang) * S * 0.3);
				ctx.stroke();
			},
		},
	};

	function makeNoise() {
		const c = document.createElement('canvas');
		c.width = c.height = 128;
		const x = c.getContext('2d');
		const im = x.createImageData(128, 128);
		for (let i = 0; i < im.data.length; i += 4) {
			const v = Math.random() * 255;
			im.data[i] = im.data[i + 1] = im.data[i + 2] = v;
			im.data[i + 3] = 255;
		}
		x.putImageData(im, 0, 0);
		return c;
	}

	class SceneCanvas extends HTMLElement {
		static get observedAttributes() {
			return ['scene'];
		}
		connectedCallback() {
			if (this._init) return;
			this._init = true;
			this.style.display = this.style.display || 'block';
			this._cv = document.createElement('canvas');
			this._cv.style.cssText = 'width:100%;height:100%;display:block';
			this.appendChild(this._cv);
			this._ctx = this._cv.getContext('2d');
			this._dpr = Math.min(window.devicePixelRatio || 1, 2);
			this._noise = makeNoise();
			this._pat = this._ctx.createPattern(this._noise, 'repeat');
			this._s = { _r: rng(1) };
			this._scene = null;
			this._cur = null;
			this._fade = 0;
			this._prev = null;
			this._vis = true;
			this._reducedMotion = window.matchMedia(
				'(prefers-reduced-motion: reduce)',
			);
			this._onReducedMotionChange = () => {
				if (this._reducedMotion.matches) {
					cancelAnimationFrame(this._raf);
					this._frame(0, 0);
				} else if (this._vis) {
					this._kick();
				}
			};
			this._reducedMotion.addEventListener(
				'change',
				this._onReducedMotionChange,
			);
			this._last = 0;
			this._ro = new ResizeObserver(() => this._resize());
			this._ro.observe(this);
			this._io = new IntersectionObserver(
				(es) => {
					this._vis = es[0].isIntersecting;
					if (this._vis) this._kick();
				},
				{ threshold: 0.01 },
			);
			this._io.observe(this);
			this._resize();
			this._apply(this.getAttribute('scene'));
			this._kick();
		}
		disconnectedCallback() {
			cancelAnimationFrame(this._raf);
			if (this._reducedMotion && this._onReducedMotionChange) {
				this._reducedMotion.removeEventListener(
					'change',
					this._onReducedMotionChange,
				);
			}
			if (this._ro) this._ro.disconnect();
			if (this._io) this._io.disconnect();
			this._init = false;
		}
		attributeChangedCallback(n, o, v) {
			if (n === 'scene' && this._init) this._apply(v);
		}
		_resize() {
			const r = this.getBoundingClientRect();
			const w = Math.max(1, Math.round(r.width)),
				h = Math.max(1, Math.round(r.height));
			if (w === this._w && h === this._h) return;
			this._w = w;
			this._h = h;
			this._cv.width = w * this._dpr;
			this._cv.height = h * this._dpr;
			this._ctx.setTransform(this._dpr, 0, 0, this._dpr, 0, 0);
		}
		_apply(name) {
			if (name === this._cur) return;
			if (this._scene && this._w && !this._reducedMotion.matches) {
				const p = document.createElement('canvas');
				p.width = this._cv.width;
				p.height = this._cv.height;
				p.getContext('2d').drawImage(this._cv, 0, 0);
				this._prev = p;
				this._fade = 1;
			}
			this._cur = name;
			this._scene = SCENES[name] || null;
			this._s = { _r: rng(hash(name || 'idle')) };
			if (this._scene && this._scene.reset)
				this._scene.reset(this._s, this._w, this._h);
			if (this._reducedMotion.matches) this._frame(0, 0);
		}
		_kick() {
			if (this._raf) cancelAnimationFrame(this._raf);
			if (this._reducedMotion.matches) {
				this._frame(0, 0);
				return;
			}
			this._last = performance.now();
			const loop = (now) => {
				const dt = Math.min(0.05, (now - this._last) / 1000);
				this._last = now;
				this._frame(now / 1000, dt);
				if (this._vis) this._raf = requestAnimationFrame(loop);
			};
			this._raf = requestAnimationFrame(loop);
		}
		_frame(t, dt) {
			const ctx = this._ctx,
				w = this._w,
				h = this._h;
			if (!w || !h) return;
			bg(ctx, w, h);
			if (this._scene && this._scene.draw)
				this._scene.draw(ctx, w, h, t, dt, this._s);
			vignette(ctx, w, h);
			ctx.save();
			ctx.setTransform(1, 0, 0, 1, 0, 0);
			ctx.globalAlpha = 0.05;
			const reducedMotion = this._reducedMotion && this._reducedMotion.matches;
			const ox = reducedMotion ? 0 : (Math.random() * 128) | 0,
				oy = reducedMotion ? 0 : (Math.random() * 128) | 0;
			ctx.fillStyle = this._pat;
			ctx.translate(-ox, -oy);
			ctx.fillRect(0, 0, this._cv.width + 128, this._cv.height + 128);
			ctx.restore();
			corners(ctx, w, h);
			if (this._fade > 0 && this._prev) {
				ctx.save();
				ctx.setTransform(1, 0, 0, 1, 0, 0);
				ctx.globalAlpha = this._fade;
				ctx.drawImage(this._prev, 0, 0);
				ctx.restore();
				this._fade -= dt / 0.5;
			}
		}
	}
	customElements.define('scene-canvas', SceneCanvas);
}
